import { getFrameMeasurements } from "../../../../../../utils/mappers/server-to-client/utils/get-frame-measurements.js";
const getSharedFrameVariantProps = ({
  frameFeatures,
  lensFeatures
}) => {
  const {
    bridgeWidth,
    color: frameColor,
    width: frameWidth,
    size: frameSize,
    templeLength
  } = frameFeatures ?? {};
  const { lensColor, lensHeight, lensWidth } = lensFeatures ?? {};
  const frameColorName = Array.isArray(frameColor) ? frameColor.join(" / ") : frameColor;
  const lensColorValue = lensColor || void 0;
  const frameColorValue = frameColorName || void 0;
  const colorFacet = [lensColorValue, frameColorValue].filter(Boolean).join(" / ");
  const frameMeasurements = getFrameMeasurements(
    bridgeWidth,
    frameWidth,
    lensHeight,
    lensWidth,
    templeLength
  );
  return {
    facets: {
      color: !!colorFacet ? colorFacet : void 0,
      size: frameSize?.size ?? void 0,
      frameColor: frameColorValue,
      frameLensColor: lensColorValue
    },
    frameMeasurements
  };
};
export {
  getSharedFrameVariantProps
};
//# sourceMappingURL=get-shared-frame-variant-props.js.map
